<template>
    <div class="d-flex">
      <welcomeComponent/>      
      <formComponent/>
    </div>
</template>

<script>
import formComponent from './components/form_component.vue';
import welcomeComponent from './components/welcome_component.vue';

export default {
  name: 'Login',
  components: {
    formComponent,
    welcomeComponent
  },
}
</script>

<style lang="css" scoped>

</style>